/**
 * @file CalculateMutualAidPaymentPrice
 */
'use strict';

/**
 * @classname CalculateMutualAidPaymentPrice
 * @classdesc CalculateMutualAidPaymentPrice
 */
 export default class CalculateMutualAidPaymentPrice {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.btn-calculate-mutual-aid-payment-price')
	 */
	constructor($e) {
		console.log('CalculateMutualAidPaymentPrice.constructor');
		this._$e = $e;
		this._$hospitalization_days = $('.hospitalization_days');
		this._$hospitalization_price = $('.hospitalization_price');
		this._$commuting_to_hospital_days = $('.commuting_to_hospital_days');
		this._$commuting_to_hospital_price = $('.commuting_to_hospital_price');
		this._$deemed_commuting_to_hospital_days = $('.deemed_commuting_to_hospital_days');
		this._$deemed_commuting_to_hospital_price = $('.deemed_commuting_to_hospital_price');
		this._$after_trouble_price = $('.after_trouble_price');
		this._$dead_price = $('.dead_price');
		this._$others_price = $('.others_price');
		this._$payment_price = $('.payment_price');
		this._$e.on('click', () => this.reCalculate());
		this._$hospitalization_days.on('change', () => this.reCalculate());
		this._$hospitalization_price.on('change', () => this.reCalculate());
		this._$commuting_to_hospital_days.on('change', () => this.reCalculate());
		this._$commuting_to_hospital_price.on('change', () => this.reCalculate());
		this._$deemed_commuting_to_hospital_days.on('change', () => this.reCalculate());
		this._$deemed_commuting_to_hospital_price.on('change', () => this.reCalculate());
		this._$after_trouble_price.on('change', () => this.reCalculate());
		this._$dead_price.on('change', () => this.reCalculate());
		this._$others_price.on('change', () => this.reCalculate());
	}


	/**
	 * 'change' のコールバック
	 *
	 * @memberof CalculateMutualAidPaymentPrice
	 * @return {undefined}
	 */
	reCalculate() {
		console.log('CalculateMutualAidPaymentPrice.reCalculate');
		this._hospitalization = (this._$hospitalization_days.val() || 0) * (this._$hospitalization_price.val() || 0);
		this._commuting_to_hospital = (this._$commuting_to_hospital_days.val() || 0) * (this._$commuting_to_hospital_price.val() || 0);
		this._deemed_commuting_to_hospital = (this._$deemed_commuting_to_hospital_days.val() || 0) * (this._$deemed_commuting_to_hospital_price.val() || 0);
		console.log(`hospitalization: ${this._hospitalization}`)
		console.log(`commuting_to_hospital: ${this._commuting_to_hospital}`)
		console.log(`deemed_commuting_to_hospital: ${this._deemed_commuting_to_hospital}`)
		console.log(`after_trouble_price: ${this._$after_trouble_price.val()}`)
		console.log(`dead_price: ${this._$dead_price.val()}`)
		console.log(`others_price: ${this._$others_price.val()}`)
		this._$payment_price.val(this._hospitalization + this._commuting_to_hospital + this._deemed_commuting_to_hospital + parseInt(this._$after_trouble_price.val() || 0) + parseInt(this._$dead_price.val() || 0) + parseInt(this._$others_price.val() || 0))
	}
}
